import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AccountTicketsFacade, RelatedCardFacade } from '@ridango/components';
import { RelatedCard } from '@ridango/core';
import Env from '@ridango/core/env';
import { AccountTicketListType } from '@ridango/widgets';

import { Observable } from 'rxjs';

@Component({
    templateUrl: './related-card-list-page.component.html',
    styleUrls: ['./related-card-list-page.component.scss']
})
export class RelatedCardListPageComponent implements OnInit {
    ticketListTypes = AccountTicketListType;
    relatedCardsLoaded$: Observable<boolean> = this.relatedCardFacade.loaded$;
    ticketsLoaded$: Observable<boolean> = this.accountTicketsFacade.loaded$;
    emailTickets$: Observable<any> = this.accountTicketsFacade.accountEmailTickets$;

    relatedCards$: Observable<RelatedCard[]> = this.relatedCardFacade.typeTravelcardCards$;
    vouchers$: Observable<any[]> = this.accountTicketsFacade.accountVoucherTickets$;
    constructor(
        private relatedCardFacade: RelatedCardFacade,
        private accountTicketsFacade: AccountTicketsFacade,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        @Inject('ENV') private env: Env
    ) {}

    ngOnInit() {
        this.relatedCardFacade.fetchAllRelatedCards();
    }

    cardSelected(card: RelatedCard) {
        this.router.navigate([card.id], { relativeTo: this.activatedRoute });
    }

    voucherSelected(voucher: any) {
        console.warn(voucher);
        alert('Voucher detail need a task!');
    }
}
